import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@hotmart/space-lib/dist/components/button'

import { Icon } from 'src/components'
import ModalHeader from 'src/components/Modal/header'
import i18n from 'src/i18n'

import clsx from 'clsx'
import { SchedulePostModalHeaderProps } from './types'

const SchedulePostModalHeader = ({
  label,
  handleGoBack,
  isStrong = true
}: SchedulePostModalHeaderProps) => (
  <ModalHeader className="_px-5 _pt-5 _pb-3">
    <div className="_d-flex _align-items-start">
      <h2
        className={clsx('_flex-1 _text-5 _text-lg-5 _m-0', {
          '_font-weight-light': !isStrong,
          '_font-weight-bold': isStrong
        })}
      >
        {label}
      </h2>
      <Button
        variation="default"
        className="_border-0 _ml-4 _py-1 _px-2 _line-height-sm"
        onClick={handleGoBack}
      >
        <span className="_sr-only">{i18n.t('buttons.close_schedule_posts_modal')}</span>
        <Icon icon={faXmark} />
      </Button>
    </div>
  </ModalHeader>
)

export default SchedulePostModalHeader
